










import Vue from 'vue'

export default Vue.extend({
  name: 'SpecialItem',
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    point: {
      type: Number,
      required: true
    },
    thumb: {
      type: String,
      required: true
    },
    thumbUploaded: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    link(): string {
      return `/trade/${this.id}`
    },
    thumbImage(): string {
      if (this.thumbUploaded) {
        return this.thumb
      } else {
        return require(`@/assets/images/benefit_placeholder.png`)
      }
    }
  }
})
